import {
  GetNotificationsDataResponse,
  NotificationsSectionData,
  UsageLimitValue,
} from "@shared/types";
import { ceil } from "lodash";
import { sharedLib } from "@shared/services/shared.service";
import {
  Platform,
  TelegramCouplingType,
} from "@shared/features/settings/types";
import { PLATFORM_TO_ACTIVE_KEY } from "@shared/features/settings/constants";

export const checkPassedQuota = (
  usage?: UsageLimitValue,
  limit?: UsageLimitValue,
  graceRatio?: number
) => {
  const isNumberUsage = typeof usage === "number";
  const isNumberLimit = typeof limit === "number";
  if (isNumberLimit && isNumberUsage) {
    const parsedLimit = graceRatio ? ceil(limit * (1 + graceRatio)) : limit;
    return usage > parsedLimit;
  } else if (usage && !limit) {
    return true;
  }
  return false;
};

export const updateNotificationsData = (
  actionTypes: number[],
  platform: Platform,
  isActive: boolean
) => {
  return sharedLib.sharedApi.notifications.util.updateQueryData(
    "getNotificationsData",
    undefined,
    (notificationsData) => {
      const isActiveKey = PLATFORM_TO_ACTIVE_KEY[platform];
      actionTypes.forEach((actionType) => {
        notificationsData.data.forEach((sectionData) => {
          const actionTypes = sectionData.data;
          const actionTypeIndex = actionTypes.findIndex(
            (actionTypeData) => actionTypeData.type === actionType
          );
          if (actionTypeIndex === -1) return;
          const actionTypeValue = actionTypes[actionTypeIndex]?.[isActiveKey];
          if (actionTypeValue === null || actionTypeValue === undefined) return;
          actionTypes[actionTypeIndex][isActiveKey] = isActive;
        });
      });
    }
  );
};

export const updateNotificationsPlatformsData = (
  platform: Platform,
  isActive: boolean
) => {
  return sharedLib.sharedApi.notifications.util.updateQueryData(
    "getNotificationsData",
    undefined,
    (notificationsData) => {
      if (platform === TelegramCouplingType.TELEGRAM_BOT)
        notificationsData.telegram_notifications_active = isActive;
      else if (platform === TelegramCouplingType.WEB_OR_APP)
        notificationsData.web_notifications_active = isActive;
    }
  );
};

export const getNotificationSettingsSections = (
  notificationsData?: GetNotificationsDataResponse
) => {
  return notificationsData?.data?.map((section) => section.name);
};

export const getSectionItem = (
  notificationsData: GetNotificationsDataResponse | undefined,
  sectionName: string
) => {
  return notificationsData?.data?.find(
    (sectionData: NotificationsSectionData) => sectionData?.name === sectionName
  );
};
